module.exports = __webpack_public_path__ + "static/pie8-cf2941bc9aa2bd82039b2a41f18aa54b.png";